export const GLOBAL_STATE = 'ReportInquiry'

export const INQUIRY_LIST = 'REPORT_INQUIRY_LIST' as const
export const INQUIRY_CREATE = 'REPORT_INQUIRY_CREATE' as const
export const INQUIRY_DELETE = 'REPORT_INQUIRY_DELETE' as const
export const INQUIRY = 'REPORT_INQUIRY' as const
export const INQUIRY_ALL = 'REPORT_INQUIRY_ALL' as const
export const INQUIRY_ITEM = 'REPORT_INQUIRY_ITEM' as const
export const INQUIRY_UPDATE_STATUS = 'RAPORT_UPDATE_STATUS' as const
export const INQUIRY_ASSIGNED = 'RAPORT_INQUIRY_ASSIGNED' as const
export const INQUIRY_COMMENTS = 'INQUIRY_COMMENTS' as const
export const INQUIRY_COMMENT_CREATE = 'INQUIRY_COMMENT_CREATE' as const
export const INQUIRY_COMMENT_DELETE = 'INQUIRY_COMMENT_DELETE' as const
export const INQUIRY_PUBLIC_INFO = 'INQUIRY_PUBLIC_INFO' as const
